import { Link, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import logo from "../../../studentassets/logo.png";
import { selectMode, toggleSideBar } from "../../../service/slice/ThemeSlice";
import { useDispatch, useSelector } from "react-redux";
import { userDetails, setUser } from '../../../service/slice/AuthSlice';


export default function LeftMenu() {

    const [openMenu, setOpenMenu] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const toggleMenu = (menuName) => {
        setOpenMenu(openMenu === menuName ? null : menuName);
    };

    const theme = useSelector(selectMode);

    const themeColor = {
        color: theme === 'light' ? '#000' : '#cacacad3',
    };

    function logout() {
        localStorage.removeItem('authAdminToken');
        dispatch(setUser({ userDetails: undefined }))
        // navigate('/adminSignin');
        window.location.href = "/adminSignin";
    }

    return (
        <>
            <aside id="layout-menu" className="layout-menu menu-vertical menu" style={{ position: 'fixed', top: 0, left: 0, height: '100vh', zIndex: 1000, overflow: 'hidden' }}>
                <div className="app-brand demo">
                    <Link to="/admin" className="app-brand-link">
                        <img src={logo} style={{ width: "64px" }} />
                    </Link>

                    <button onClick={() => { dispatch(toggleSideBar()) }} className="layout-menu-toggle menu-link text-large ms-auto" style={themeColor}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.47365 11.7183C8.11707 12.0749 8.11707 12.6531 8.47365 13.0097L12.071 16.607C12.4615 16.9975 12.4615 17.6305 12.071 18.021C11.6805 18.4115 11.0475 18.4115 10.657 18.021L5.83009 13.1941C5.37164 12.7356 5.37164 11.9924 5.83009 11.5339L10.657 6.707C11.0475 6.31653 11.6805 6.31653 12.071 6.707C12.4615 7.09747 12.4615 7.73053 12.071 8.121L8.47365 11.7183Z"
                                fillOpacity="0.9" />
                            <path
                                d="M14.3584 11.8336C14.0654 12.1266 14.0654 12.6014 14.3584 12.8944L18.071 16.607C18.4615 16.9975 18.4615 17.6305 18.071 18.021C17.6805 18.4115 17.0475 18.4115 16.657 18.021L11.6819 13.0459C11.3053 12.6693 11.3053 12.0587 11.6819 11.6821L16.657 6.707C17.0475 6.31653 17.6805 6.31653 18.071 6.707C18.4615 7.09747 18.4615 7.73053 18.071 8.121L14.3584 11.8336Z"
                                fillOpacity="0.4" />
                        </svg>
                    </button>
                </div>

                <div className="menu-inner-shadow"></div>

                <ul className="menu-inner py-1" style={{ height: 'calc(100vh - 80px)', overflowY: 'auto', overflowX: 'hidden', paddingRight: '10px' }}>

                    {/* Dashboard */}
                    <li className="menu-item">
                        <Link to="/admin" className="menu-link">
                            <i className="menu-icon icon-base ri ri-home-smile-line"></i>
                            <div data-i18n="Email" style={themeColor}>Dashboard</div>
                        </Link>
                    </li>

                    <li className="menu-header small mt-2"></li>

                    {/* User */}
                    <li className="menu-item">
                        <Link to="#" className="menu-link menu-toggle flex items-center justify-between" onClick={() => toggleMenu("Products")}>
                            {/* <FaRegUser style={{ fontWeight: "900", fontSize: "18px", margin: "1px 10px 2px 2px" }} /> */}
                            <i className="menu-icon icon-base ri ri-user-fill"></i>
                            <div data-i18n="Products">User</div>
                            <MdKeyboardArrowRight className={`transition-transform dropdown-arrow duration-300 ${openMenu === "Products" ? "rotate-90" : "rotate-0"}`} />
                        </Link>

                        <ul className={`overflow-hidden transition-all duration-500 ease-in-out ${openMenu === "Products" ? "max-h-40 opacity-100" : "max-h-0 opacity-0 d-none"}`}>
                            <li className="menu-item">
                                <Link to="/admin/userlist" className="menu-link flex items-center gap-2">
                                    <GoDotFill className="w-2 h-2 text-gray-600 fill-current" />
                                    <div data-i18n="User List">User List</div>
                                </Link>
                            </li>
                        </ul>
                    </li>


                    {/* Package */}
                    <li className="menu-item">
                        <Link to="/admin/package" className="menu-link">
                            {/* <GoPackageDependencies style={{ fontWeight: "900", fontSize: "18px", margin: "1px 10px 2px 2px" }} /> */}
                            <i className="menu-icon icon-base ri ri-instance-fill"></i>
                            <div data-i18n="Email">Package</div>
                        </Link>
                    </li>

                    {/* Subscription */}
                    <li className="menu-item">
                        <Link to="/admin/subscriptionhistory" className="menu-link">
                            <i className="menu-icon icon-base ri ri-lifebuoy-line"></i>
                            <div data-i18n="Support">Subscription</div>
                        </Link>
                    </li>

                    {/* Contact */}
                    <li className="menu-item">
                        <Link to="/admin/contact" className="menu-link">
                            <i className="menu-icon icon-base ri ri-contacts-book-line"></i>
                            <div data-i18n="Support">Contact</div>
                        </Link>
                    </li>

                    {/* Settings */}
                    <li className="menu-item">
                        <Link to="#" className="menu-link menu-toggle flex items-center justify-between" onClick={() => toggleMenu("Settings")}>
                            {/* <IoSettingsOutline style={{ fontWeight: "900", fontSize: "18px", margin: "1px 10px 2px 2px" }} /> */}
                            <i className="menu-icon icon-base ri ri-settings-3-line"></i>
                            <div data-i18n="Settings">Settings</div>
                            <MdKeyboardArrowRight className={`transition-transform dropdown-arrow duration-300 ${openMenu === "Settings" ? "rotate-90" : "rotate-0"}`} />
                        </Link>

                        <ul className={`overflow-hidden transition-all duration-500 ease-in-out ${openMenu === "Settings" ? "max-h-40 opacity-100" : "max-h-0 opacity-0 d-none"}`}>
                            <li className="menu-item">

                                <Link to="/admin/board" className="menu-link flex items-center gap-2">
                                    <GoDotFill className="w-2 h-2 text-gray-600 fill-current" />
                                    <div>Study Profile</div>
                                </Link>

                                <Link to="/admin/masterlanguage" className="menu-link flex items-center gap-2">
                                    <GoDotFill className="w-2 h-2 text-gray-600 fill-current" />
                                    <div >Language Master</div>
                                </Link>

                                <Link to="/admin/mastersubject" className="menu-link flex items-center gap-2">
                                    <GoDotFill className="w-2 h-2 text-gray-600 fill-current" />
                                    <div >Subject Master</div>
                                </Link>

                            </li>
                        </ul>
                    </li>

                    {/* Logout */}
                    <li className="menu-item">
                        <Link className="menu-link" onClick={() => { logout() }}>
                            <i class="menu-icon icon-base ri ri-logout-box-r-line"></i>
                            <div data-i18n="Support">Logout</div>
                        </Link>
                    </li>

                </ul>

            </aside>
        </>
    )
}
